import ReviewPhotos from './review-photos.graphql';

const getReviewsPhotosQuery = () => {
  return ReviewPhotos;
};
export default getReviewsPhotosQuery;
